import { render, staticRenderFns } from "./ShoppingCartCounter.vue?vue&type=template&id=4457eb00&scoped=true&"
import script from "./ShoppingCartCounter.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartCounter.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartCounter.vue?vue&type=style&index=0&id=4457eb00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4457eb00",
  null
  
)

export default component.exports